import { FC } from "react";
import Row from "./Row";
import { ReactComponent as ArrowIcon } from "images/TickIcon.svg";
import cn from "classnames";
import styles from "./Table.module.sass";
import { DocumentPatternResponse } from "libs/apiClient/data-contracts";

interface TableProps {
	documents: DocumentPatternResponse[];
	handleCreateDocument: (row: DocumentPatternResponse) => void;
	getData: () => void;
	openConfirm: (cb: () => void, mode: "remove" | "update") => void;
	error: { read: boolean; edit: { active: boolean; snack(): void }; editItems: boolean };
}

const Table: FC<TableProps> = ({ documents, error, openConfirm, getData, handleCreateDocument }) => {
	return (
		<div>
			<div className={styles.head}>
				<div className={styles.row}>Название документа</div>
				<div className={cn(styles.row, styles.download)}>Актуальный шаблон</div>
				<div className={cn(styles.row, styles.sort)}>
					Дата обновления <ArrowIcon className={styles.arrowIcon} />
				</div>
				<div className={styles.row}>Загрузил</div>
				<div className={styles.row}>Тип документа</div>
				<div className={styles.row}></div>
			</div>
			<div className={styles.body} data-comment-false={true}>
				{documents.map((row) => (
					<Row
						error={error}
						openConfirm={openConfirm}
						key={row.id}
						getData={getData}
						row={row}
						handleCreateDocument={handleCreateDocument}
					/>
				))}
			</div>
		</div>
	);
};

export default Table;
